import { PageActions, UPDATE_PAGE } from "./action";
import produce from "immer";
import { CONTENT_TYPES } from "../../typings/document-types";
///
/*
    Only holds one page at any given time.
*/
///

export interface CurrentPageState
{
    page?: CONTENT_TYPES;
    statusCode?: number;
    redirectUrl?: string;
}

const initialState: CurrentPageState =
{
    page: undefined,
    statusCode: undefined
};

export const reducer = (pageState = initialState, action: PageActions): CurrentPageState => produce(pageState, draft =>
{
    switch (action.type)
    {
        case UPDATE_PAGE: {
            draft.page = action.page;
            draft.statusCode = action.statusCode;
            draft.redirectUrl = action.redirectUrl;
        }
    }
});

export const getPage = (state: CurrentPageState) => state.page;

export default reducer;